import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-busy-spinner-icon',
  templateUrl: './busy-spinner-icon.component.html',
  styleUrls: ['./busy-spinner-icon.component.scss']
})
export class BusySpinnerIconComponent {
  @Input() diameter = 20;
  @Input() isLoading = false;
  @Input() isBusyCounter = 0;

}
